import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { css } from 'aphrodite/no-important';
import { I18n } from 'react-redux-i18n';
import styles from '../resetpassword/ResetPassword.styles';
import { resetPasswordAction,verifyPasswordTokenAction, resendVerifyAction } from '../../reducers/actions';
import NewUserForm from '../../components/forms/newuser/NewUserForm';
import logo from '../../assets/logo_white.png';
import Image from '../../components/common/image/Image';

export class NewUser extends Component {
  state = {
    email: null,
    token: null
  };
  onSubmit = values => {
    let p = values.password;
    let {token, email } = this.state;
    this.props.resetPasswordAction(email, token, p);
  };
  email = null
  token = null
  locationParams(){
    try{
      let s = new URLSearchParams(document.location.search)
      return {
        email: s.get('email'),
        token: s.get('key')
      }
    }catch(e){
      console.log('issue parsing search params')
      return {}
    }
  }
  componentDidMount(){
    let o = this.locationParams()
    this.setState(o)
    if(o.email && o.token){
      this.props.verifyToken(o.email,o.token)
    }
  }
  handleResend(e){
    e.stopPropagation();
    e.preventDefault();
    this.props.resendVerify(this.state.email);
  }
  render() {
    let obj = (<NewUserForm email={this.state.email} token={this.state.token} 
      error={this.state.error}
      onSubmit={this.onSubmit} />) 
    if(!this.state.email || !this.state.token){
      obj = (<div className={css(styles.outline)}>
      <Image src={logo} alt="logo" styles={styles.logo} />
      <div className={css(styles.msg)}><p>{I18n.t('newuser.invalidParameters')}</p>
        </div>
      </div>)
    }
    if(!this.props.tokenValid){
      obj = (<div className={css(styles.outline)}>
      <Image src={logo} alt="logo" styles={styles.logo} />
      <div className={css(styles.msg)}><p>{I18n.t('resetPassword.invalidToken')}</p>
      <a href="" onClick={(e)=>{this.handleResend(e)}} className={css(styles.link)}>
          {I18n.t('newuser.resendEmailTxt')}   
        </a>
        </div>
      </div>)
    }
    if(this.props.resendVerifyCompleted){
      obj = (<div className={css(styles.outline)}>
      <Image src={logo} alt="logo" styles={styles.logo} />
      <div className={css(styles.msg)}><p>{I18n.t('newuser.resendEmailSuccess')}</p></div>
      </div>)
    }
    
    if(this.props.resetPasswordCompleted){
      obj = (<div className={css(styles.outline)}>
      <Image src={logo} alt="logo" styles={styles.logo} />
      <div className={css(styles.msg)}><p>{I18n.t('newuser.success')}</p>
      <Link to="/login" className={css(styles.link)}>
          {I18n.t('login.login')}      
        </Link>
      </div>
      </div>)
    }
    return (
      <div className={css(styles.base)}>
      {obj}
      </div>
    );
  }
}

const mapStateToProps = ({auth}) => {
  let resetPasswordCompleted = auth.resetPasswordCompleted;
  let resendVerifyCompleted = auth.resendVerifyCompleted;
  let tokenValid = auth.tokenValid;
  return { resetPasswordCompleted, tokenValid, resendVerifyCompleted };
};

const mapDispatchToProps = dispatch => {
  return {
    resetPasswordAction() {
      dispatch(resetPasswordAction(...arguments));
    },
    verifyToken(){
      dispatch(verifyPasswordTokenAction(...arguments));
    },
    resendVerify(){
      dispatch(resendVerifyAction(...arguments));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewUser);



// WEBPACK FOOTER //
// ./src/containers/newuser/NewUser.js